import { render } from "./BlListField.vue?vue&type=template&id=57f6b989"
import script from "./BlListField.vue?vue&type=script&lang=js"
export * from "./BlListField.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/5ea1362f-94e3-43d0-86d7-afc144980eef/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__